import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateLeft } from '@fortawesome/free-solid-svg-icons';

export const PrevButton = React.memo(({ content, onClick, disabled }) => (
  <Button variant="success" onClick={onClick} disabled={disabled} title={content}>
    <FontAwesomeIcon icon={faRotateLeft} className="me-2" />
    {content}
  </Button>
));

PrevButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

PrevButton.defaultProps = {
  content: 'Previous',
  disabled: false,
};

export default PrevButton;
